import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import WaLink, { btnPrimary, btnAccent, eyebrow } from './WaLink';
import { img } from '../data/salon';

const details = [
  ['FiMapPin', 'Agra, Uttar Pradesh, India'],
  ['FiPhone', '+91 98765 43210'],
  ['FiClock', '10:00 AM – 8:00 PM, Mon–Sun'],
];

function Contact() {
  return (
    <section id="contact" className="mx-auto grid max-w-[1280px] gap-8 px-4 py-20 sm:px-6 lg:grid-cols-2">
      <div className="flex flex-col justify-center">
        <span className={eyebrow}>Contact &amp; location</span>
        <h2 className="font-display mt-3 text-4xl text-[#0B3B36] sm:text-5xl">
          Visit us in <em className="text-[#C8553D]">Agra.</em>
        </h2>
        <div className="my-7 space-y-3">
          {details.map(([icon, text]) => (
            <WaLink
              key={text}
              className="flex items-center gap-4 rounded-xl bg-[#E4EDE6] p-4 text-[#0B3B36] transition hover:bg-[#d5e3d9]"
            >
              <span className="grid h-11 w-11 place-items-center rounded-lg bg-[#0B3B36] text-[#E9A23B]">
                <SafeIcon icon={FiIcons[icon]} />
              </span>
              <span className="font-display text-lg">{text}</span>
            </WaLink>
          ))}
        </div>
        <div>
          <WaLink className={btnPrimary}>
            Message us on WhatsApp <SafeIcon icon={FiIcons.FiArrowUpRight} />
          </WaLink>
        </div>
      </div>
      <div className="h-[420px] overflow-hidden rounded-2xl border-8 border-white shadow-xl">
        <iframe
          title="Map of Agra, Uttar Pradesh"
          src="https://maps.google.com/maps?q=Agra%2C%20Uttar%20Pradesh%2C%20India&t=&z=12&ie=UTF8&iwloc=&output=embed"
          className="h-full w-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
}

function FinalCTA() {
  return (
    <section className="px-3 pb-6 sm:px-6">
      <div className="salon-cta-inner relative mx-auto flex min-h-[380px] max-w-[1280px] flex-col items-center justify-center overflow-hidden rounded-2xl p-8 text-center text-white">
        <img src={img.cta} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#0B3B36]/80" />
        <div className="relative">
          <h2 className="font-display text-4xl sm:text-6xl">
            Ready to <em className="text-[#E9A23B]">glow?</em>
          </h2>
          <WaLink className={`${btnAccent} mt-8`}>
            Book Appointment <SafeIcon icon={FiIcons.FiArrowUpRight} />
          </WaLink>
        </div>
      </div>
    </section>
  );
}

const quick = [
  ['About', '#about'],
  ['Services', '#services'],
  ['Bridal', '#bridal'],
  ['Gallery', '#gallery'],
  ['Packages', '#packages'],
  ['FAQ', '#faq'],
];

const services = ['Bridal makeup', 'Hair styling', 'Facials', 'Manicure & pedicure'];
const socials = [
  ['FaInstagram', 'Instagram'],
  ['FaFacebookF', 'Facebook'],
  ['FaWhatsapp', 'WhatsApp'],
];

function Footer() {
  return (
    <footer className="mt-10 bg-[#082b27] text-[#dfe8e4]">
      <div className="mx-auto grid max-w-[1280px] gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
        <div>
          <p className="font-display text-2xl text-white">
            Blush <i className="text-[#E9A23B]">&amp;</i> Bloom
          </p>
          <p className="mt-3 text-sm text-[#a9bcb6]">Luxury beauty studio · Agra, Uttar Pradesh</p>
          <p className="mt-2 text-sm text-[#a9bcb6]">+91 98765 43210</p>
          <div className="mt-5 flex gap-3">
            {socials.map(([name, label]) => (
              <WaLink
                key={name}
                aria-label={`${label} via WhatsApp`}
                className="grid h-10 w-10 place-items-center rounded-full border border-white/20 transition hover:bg-[#E9A23B] hover:text-[#0B3B36]"
              >
                <SafeIcon icon={FaIcons[name]} />
              </WaLink>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-display mb-3 text-lg text-[#E9A23B]">Quick links</h3>
          <ul className="space-y-2 text-sm text-[#a9bcb6]">
            {quick.map(([label, href]) => (
              <li key={href}>
                <a href={href} className="hover:text-white">{label}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-display mb-3 text-lg text-[#E9A23B]">Services</h3>
          <ul className="space-y-2 text-sm text-[#a9bcb6]">
            {services.map((service) => (
              <li key={service}><WaLink className="hover:text-white">{service}</WaLink></li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-display mb-3 text-lg text-[#E9A23B]">Hours</h3>
          <p className="text-sm text-[#a9bcb6]">Every day<br />10:00 AM – 8:00 PM</p>
        </div>
      </div>
      <div className="border-t border-white/10 px-4 py-5 text-center text-xs text-[#8aa098]">
        © {new Date().getFullYear()} Blush &amp;Bloom Beauty Studio. Demo website.
      </div>
    </footer>
  );
}

function FloatingWhatsApp() {
  return (
    <WaLink
      className="fixed bottom-4 right-4 z-40 flex items-center gap-2 drop-shadow-xl sm:bottom-6 sm:right-6"
      aria-label="Contact Blush & Bloom on WhatsApp"
    >
      <span className="whatsapp-contact-label rounded-lg bg-[#0B3B36] px-4 py-2.5 text-xs font-bold text-white sm:text-sm">
        Contact Us
      </span>
      <span className="grid h-14 w-14 place-items-center rounded-full border-4 border-white bg-[#25D366] text-3xl text-white shadow-lg">
        <SafeIcon icon={FaIcons.FaWhatsapp} />
      </span>
    </WaLink>
  );
}

export { Contact, FinalCTA, Footer, FloatingWhatsApp };
